import * as React from "react";
import { useTranslation } from "react-i18next";
import { DropdownButton, MenuItem } from "components/bootstrap";
const AggregationElementSelect = ({ aggregationElements, onSelect, formValues }) => {
  const { t } = useTranslation("aggregation");
  const menuItems = aggregationElements.filter(({ allowCreate }) => allowCreate(formValues)).map(({ key, title, titleKey }) => /* @__PURE__ */ React.createElement(MenuItem, { key: `element-select-${key}`, onSelect: () => onSelect(key) }, titleKey ? t(titleKey) : title));
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      id: "add-aggregation-element",
      title: t("wizard_common.add"),
      buttonTitle: t("wizard_common.add_element")
    },
    menuItems
  );
};
export default AggregationElementSelect;
